import React from 'react'

const CheckBoxUncheckedIcon = props => (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" transform="translate(3 0)" {...props} >
            <rect width="17" height="17" x="20.5" y="20.5" fill="none" rx="3" transform="translate(-20 -20)"/>
        </svg>
);

export default CheckBoxUncheckedIcon;